export default {
  test: 'test lang',
};
